// extracted by mini-css-extract-plugin
export default {"sectionTitle":"TemplateList_sectionTitle__uVSwp","templateList":"TemplateList_templateList__lGqML","templatesContainer":"TemplateList_templatesContainer__w8SeB"};